import styled from 'styled-components'

const PricePlanRowUi = styled.div`
  display: flex;
  margin: 10px 0;
`

export default PricePlanRowUi
